// extracted by mini-css-extract-plugin
export default {"inputErrorMessage":"InputErrorMessage_inputErrorMessage__JEogq"};